/* globals $ */
import SCWaveform from './lib/soundcloud/sc-player-waveform.js'
import SoundCloudPlayer from './lib/soundcloud/sc-player.js'
// import envmap from './envmap.js'
class CustomSoundCloudPlayer {
  constructor (_setURL, _customerKey) {
    let elements = `
      <section id="playbar">
        <div id="player">
          <div class="time"></div>
          <div class="controls">
            <div class="prev"></div>
            <div class="play"></div>
            <div class="next"></div>
          </div>
          <div id="waveform">
            <div class="buffer"></div>
            <div class="played"><div id="point"></div></div>
            <img src='/assets/images/player/nothing.png'/>
          </div>
          <div class="infos"></div>
          <img class="cover" src=''/>
        </div>
      </section>
    `

    var body = document.body
    body.insertAdjacentHTML('beforeend', elements)
    _customerKey = '524c5acd5e5c401654259eb487c4bfb2'
    this.controls = $('.controls')
    this.cover = $('.cover')[0]
    this.prev = $('.prev')[0]
    this.next = $('.next')[0]
    this.current_track = null
    this.playlist = null
    this.scplayer = new SoundCloudPlayer([_setURL], {
      consumer_key: _customerKey,
      autoplay: true,
      loop: true,
      toggle_pause: true,
      preload: true
    })

    this.scwaveform = new SCWaveform(this.scplayer, {
      scrub: true
    })

    // EVENTS
    this.controls.on('click', 'div', function (e) {
      e.preventDefault()
      var node = $(e.currentTarget)
      if (node.hasClass('play')) {
        this.scplayer.pause()
      } else if (node.hasClass('pause')) {
        this.scplayer.pause()
      } else if (node.hasClass('stop')) {
        this.scplayer.stop()
      } else if (node.hasClass('next')) {
        this.scplayer.next()
      } else if (node.hasClass('prev')) {
        this.scplayer.prev()
      }
    }.bind(this))
    this.scplayer.on('scplayer.pause', function (e, iPaused) {
      if (iPaused === true) {
        this.controls.find('.play').addClass('pause')
      } else {
        this.controls.find('.play').removeClass('pause')
      }
    }.bind(this))
    this.scplayer.on('scplayer.init', function (e) {
      var playlist = e.currentTarget.get_playlist()
      if (playlist.length === 1) {
        this.prev.style.visibility = 'hidden'
        this.next.style.visibility = 'hidden'
      }
    }.bind(this))
    this.scplayer.on('scplayer.changing_track', function (e, index) {
      this.scplayer.track_info(index).done(function (track) {
        var title = '<p>' + track.title + '</p>'
        $('#trackName').html(title)
        $('.infos').html(title)
        this.cover.src = track.artwork_url
      }.bind(this))
      this.current_track = index
    }.bind(this))
    this.scplayer.on('scplayer.track.whileplaying', function (e, percent) {
      $('.time').html('<p>' + Math.round(percent) + ' % <p>')
    })
  }

  play (index) {
    this.scplayer.goto(index).play()
    this.current_track = index
  }

  getCurrentTrack () {
    return this.current_track
  }
}

export default CustomSoundCloudPlayer
